// extracted by mini-css-extract-plugin
export var container = "OrderSelect-module--container---tNN6";
export var content = "OrderSelect-module--content--iDUxg";
export var noOrders = "OrderSelect-module--noOrders--rHEwM";
export var subHeader = "OrderSelect-module--subHeader--tvbzw";